import { render } from "./ButtonSearch.vue?vue&type=template&id=1084e2a5"
import script from "./ButtonSearch.vue?vue&type=script&lang=js"
export * from "./ButtonSearch.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__